import './pdf-viewer-page.scss'

import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const PDFViewerPage = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        // pdfjs-dist ships no TypeScript declarations here, so the PDFDocumentProxy stays untyped upstream too.
        pdf: { type: Object as PropType<any> },
        pageIndex: {},
        highlighted: {},
        scale: {},
    },
    template: require('./pdf-viewer-page.html'),
    data() {
        return {
            renderingInProgress: false,
            ready: false,
        }
    },
    computed: {
        pdfCanvas(): HTMLCanvasElement {
            return this.$refs.pdfCanvas as HTMLCanvasElement;
        },
    },
    methods: {
        setupPage(pageIndex) {
            if (this.pdf && !this.renderingInProgress) {
                this.renderingInProgress = true;
                this.pdf.getPage(pageIndex).then((page) => {

                    const viewport = page.getViewport({ scale: this.scale });

                    // Prepare canvas using PDF page dimensions
                    const context = this.pdfCanvas.getContext('2d');
                    this.pdfCanvas.height = viewport.height;
                    this.pdfCanvas.width = viewport.width;

                    // Render PDF page into canvas context
                    const renderContext = {
                        canvasContext: context,
                        viewport
                    };
                    const renderTask = page.render(renderContext);
                    renderTask.promise.then(() => {
                        this.ready = true;
                        this.renderingInProgress = false;
                    });
                });
            }
        },
    },
    watch: {
        pageIndex: {
            handler(pageIndex) {
                this.setupPage(pageIndex)
            },
            immediate: true,
        },
        scale() {
            this.setupPage(this.pageIndex)
        },
    },
})
